export const tooltip = (title, points, names, colors) => {
  const newColors = colors.map(color => {
    if (color === '#79a0ed') return '#b1c8f5';
    if (color === '#5189f7') return '#79a2f7';
    if (color === '#2a5dca') return '#4a79dd';
    return color;
  });

  return `
      <div style="padding:8px; opacity: 0.9; background-color: #122a57; border-radius:2px;">
        <h4 style="margin: 0; color: #ffffff; font-family: Inter; font-size: 11px;">
          ${title}
        </h4>
        ${points.map((point, ind) => {
          return `
            <p style="margin-top: 8px; margin-bottom: 0; display: flex; justify-content: space-between;
            font-family: Inter; font-size: 11px;">
              <span style="margin-right: 8px">
                <span style="display: inline-block; width: 8px; height: 8px; background-color: ${newColors[ind]};"></span>
                <span style="color: #ffffff;">${names[ind]}:</span>
              </span>
              <span style="color: #ffffff;">${point}</span>
          </p>`;
        })}
      </div>`.replace(/,/g, '');
};
